var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?[_c('ob-spinner',{attrs:{"loading-text":"Loading..."}})]:[_c('task-table',{attrs:{"TaskList":_vm.TaskList,"tasksTotalCount":_vm.tasksTotalCount,"IsFilter":_vm.IsFilter,"isSupervisor":_vm.isSupervisor},on:{"update:TaskList":function($event){_vm.TaskList=$event},"update:tasksTotalCount":function($event){_vm.tasksTotalCount=$event}}})]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cf24022","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ESSProfile/Tasks/Task.vue
// module id = null
// module chunks = 